import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../lib/supabaseClient';
import { MarketingHeader } from '../../components/marketing/MarketingHeader';
import { MarketingFooter } from '../../components/marketing/MarketingFooter';

export const AuthCallback = () => {
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let isMounted = true;
    let timeoutId: number | undefined;

    const redirectPath =
      typeof window !== 'undefined'
        ? window.sessionStorage.getItem('postAuthRedirect') ?? '/simulations'
        : '/simulations';

    const completeSignIn = () => {
      if (!isMounted) {
        return;
      }

      if (timeoutId) {
        clearTimeout(timeoutId);
      }

      if (typeof window !== 'undefined') {
        window.sessionStorage.removeItem('postAuthRedirect');
      }

      navigate(redirectPath, { replace: true });
    };

    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((_event, session) => {
      if (session) {
        completeSignIn();
      }
    });

    supabase.auth
      .getSession()
      .then(({ data, error }) => {
        if (!isMounted) {
          return;
        }

        if (error) {
          setError(error.message);
          return;
        }

        if (data.session) {
          completeSignIn();
        }
      })
      .catch((authError) => {
        if (!isMounted) {
          return;
        }
        setError(authError.message ?? 'An unexpected error occurred.');
      });

    timeoutId = typeof window !== 'undefined'
      ? window.setTimeout(() => {
          if (!isMounted) {
            return;
          }
          setError('We could not complete the sign-in process. Please try again.');
        }, 15000)
      : undefined;

    return () => {
      isMounted = false;
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      subscription.unsubscribe();
    };
  }, [navigate]);

  return (
    <div className="marketing-page">
      <MarketingHeader />

      <section className="marketing-hero">
        <div className="marketing-container">
          <div className="marketing-signup-content">
            <div className="marketing-signup-header">
              <h1 className="marketing-hero-title">{error ? 'Sign in failed' : 'Signing you in...'}</h1>
              <p className="marketing-hero-description">
                {error
                  ? error
                  : 'Please wait a moment while we securely connect your Google account.'}
              </p>

              {!error && (
                <div className="loading-container" role="status" aria-live="polite">
                  <div className="loading-spinner">Completing sign-in…</div>
                </div>
              )}

              {error && (
                <div style={{ marginTop: '1.5rem' }}>
                  <button
                    type="button"
                    onClick={() => navigate('/login', { replace: true })}
                    className="marketing-btn marketing-btn-secondary marketing-btn-large"
                  >
                    Back to login
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>

      <MarketingFooter />
    </div>
  );
};

